import EmaButton from "components/emaButton/EmaButton";
import EmaInput from "components/emaInput/EmaInput";
import React, { useState } from "react";
//import findError from "utils/findError";
import PhoneInput from "react-phone-number-input";
import "assets/styles/PhoneInput.sass";
const UserDetailWrapper = ({ state, dispatchUser }) => {
  return (
    <div className="ema-card mt-0">
      <div className="ema-card-title">General</div>
      {/*  <div className="ema-card">
        </div> */}
      <div className="row">
        <div className="col-12 col-lg-6 col-xl-6">
          <EmaInput
            type="text"
            label="Email"
            name="email"
            value={state?.email}
            onChange={(e) => {
              dispatchUser({
                type: e.target.name,
                value: e.target.value,
              });
            }}
            disabled
          />
        </div>
        <div className="col-12 col-lg-6 col-xl-6">
          <EmaInput
            type="text"
            label="First Name"
            name="givenName"
            value={state?.givenName}
            onChange={(e) => {
              dispatchUser({
                type: e.target.name,
                value: e.target.value,
              });
            }}
          />
        </div>
        <div className="col-12 col-lg-6 col-xl-6">
          <EmaInput
            type="text"
            label="Last Name"
            name="familyName"
            value={state?.familyName}
            onChange={(e) => {
              dispatchUser({
                type: e.target.name,
                value: e.target.value,
              });
            }}
          />
        </div>

        <div className="col-12 col-lg-6 col-xl-6">
          <label className="phone-input-label" htmlFor="phone">
            Primary Phone{/* <span className="required-red">*</span> */}
          </label>
          <PhoneInput
            className={
              "phone-input"
              //classNames("phone-input", {
              //"phone-error": findError(`[${index}].Phone`, errors),})
            }
            defaultCountry="ET"
            international
            value={state?.phone}
            onChange={(value) => {
              dispatchUser({
                type: "phone",
                value: value,
              });
            }}
          />
          <span className="phone-error-message"></span>
        </div>

        {/*    <div className="col-12 col-lg-12 col-xl-12">
            <EmaInput
              type="select"
              options={usrTyp}
              label="User Type"
              name="user_type"
            />
          </div> */}
      </div>
    </div>
  );
};
export default UserDetailWrapper;
